import React,{useEffect} from "react";
import { Link } from "react-router-dom";

import NotificationDropdown from "./NotificationDropdown.js";
import UserDropdown from "./UserDropdown.js";
import { BiNotification } from "react-icons/bi";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  waitForPendingWrites,
  updateDoc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const [request, setrequest] = React.useState();
  const [notification, setnotification] = React.useState();
  const db = getFirestore();

  useEffect(() => {

    onSnapshot(
      query(
        collection(db, "request"),
        where("user_uid", "==", localStorage.getItem("user_uid")),
        where("newUser", "==", "yes")
      ),
      (querySnapshot) => {
        let arr = [];
        querySnapshot.forEach((doc) => {
          console.log("gyuyy", doc.data());
          arr.push(doc.data());
        });

        setrequest(arr);
        setnotification(arr.length);
      }
      );
    }, []);
    
      const update = () => {
        // update
    
        for (const v of request) {
          const db = getFirestore();
    
          const washingtonRef = doc(db, "request", v.request_uid);
          updateDoc(washingtonRef, {
            newUser: "no",
          });
        }
      };
  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="#"
          >
            <img
              className="hidden md:block lg:block h-6 w-auto"
              style={{
                width: 120,
                height: 90,
                position: "absolute",
                top: 5,
                objectFit: "cover",
              }}
              src={require("../../../image/logo.png")}
            />

          </Link>
          {/* User */}
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4  absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap w-100 align-items-center justify-content-between">
                <img
                  style={{ height: 40, objectFit: "cover" }}
                  src={require("../../../image/logo.png")}
                />

                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}

            {/* Navigation */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className="text-pink-500 hover:text-pink-600 text-xs uppercase py-3 font-bold block"
                  to="/dashboard"
                >
                  <i className="fas fa-tv opacity-75 mr-2 text-sm"></i>{" "}
                  Dashboard
                </Link>
              </li>

            
              <li className="items-center">
                <Link
                  className="text-pink-500 hover:text-pink-600 text-xs uppercase py-3 font-bold block"
                  to="/Sheduled"
                  onClick={() => {
                    update();
                  }}
                >
                 <div className="d-flex flex-row align-items-center">
                    <i className="fas fa-newspaper text-blueGray-400 mr-2 text-sm"></i>
                    Sheduled History
                    {notification > 0 ? (
                      <div
                        className="d-flex flex-row align-items-center justify-content-center"
                        style={{
                          minWidth: 20,
                          height: 20,
                          borderRadius: 20,
                          backgroundColor: "#DB2777",
                          color: "#fff",
                          marginLeft: 8,
                          padding: 2,
                        }}
                      >
                        {notification}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className="text-pink-500 hover:text-pink-600 text-xs uppercase py-3 font-bold block"
                  to="/Profile"
                >
                  <i className="fas fa-user opacity-75 mr-2 text-sm"></i>{" "}
                  Profile
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
